import type { RouteRecordRaw } from 'vue-router';

import { visionHubAccessGuard } from '@/app/visionHub/utils/route-guards';

export default {
  path: '/vision',
  component: () => import('@/app/visionHub/App.vue'),
  beforeEnter: visionHubAccessGuard,
  meta: {
    requiresAuth: true,
    hideVisionAi: true,
    fillHeight: true,
  },
  children: [
    {
      name: 'vision.landing',
      path: '',
      component: () => import('@/app/visionHub/pages/Landing.vue'),
      meta: {
        analytics: 'Vision - New Chat',
      },
    },
    {
      name: 'vision.chat',
      path: 'chat/:conversationId',
      component: () =>
        import('@/components/VisionAi/chat-panel-components/VisionChatSidePanel.vue'),
      props: { page: true },
      meta: {
        analytics: 'Vision - Chat',
        fillHeight: false,
      },
    },
    {
      name: 'vision.tasks.overview',
      path: ':brandLabel/agent-tasks',
      component: () => import('@/app/visionHub/pages/TaskOverview.vue'),
      meta: { analytics: 'Vision - Task Overview' },
    },
    {
      name: 'vision.tasks.scheduled',
      path: ':brandLabel/agent-tasks/scheduled',
      component: () => import('@/app/visionHub/pages/ScheduledTasks.vue'),
      meta: { analytics: 'Vision - Scheduled Tasks' },
    },
    ...[
      { name: 'vision.tasks.live', path: ':brandLabel/agent-tasks/live' },
      { name: 'vision.tasks.live.community', path: ':brandLabel/agent-tasks/live/community' },
      { name: 'vision.tasks.live.content', path: ':brandLabel/agent-tasks/live/content' },
      { name: 'vision.tasks.live.performance', path: ':brandLabel/agent-tasks/live/performance' },
    ].map(({ name, path }) => ({
      name,
      path,
      component: () => import('@/app/visionHub/pages/LiveTasks.vue'),
      meta: { analytics: 'Vision - Live Tasks' },
    })),
  ],
} satisfies RouteRecordRaw;
